export const GET_DRIVER_VIEWORDER_STATES="pay-citation/GET_DRIVER_VIEWORDER_STATES";
export const SET_DRIVER_VIEWORDER_STATES="pay-citation/SET_DRIVER_VIEWORDER_STATES";

export const getDriverViewOrderStates=(data)=>{
    return{
        type:GET_DRIVER_VIEWORDER_STATES,
        payload:data
    }
}
export const setDriverViewOrderStates=(data)=>{
    return{
        type:SET_DRIVER_VIEWORDER_STATES,
        payload:data
    }
}